import React from "react";
import { SHr, SNavigation, SPage, SText, STheme, SView } from "servisofts-component2";
// import BottomNavigator from "../../Components/BottomNavigator";
import Container from "../../Components/Container";
import SectionHeader from "./Components/SectionHeader";
import SectionForm from "./Components/SectionForm";
// import SectionFooter from "./Components/SectionFooter";
// import SectionRegister from "./Components/SectionRegister";
// import SectionApis from "./Components/SectionApis";
import MDL from "../../MDL";

export default class index extends React.Component {
    // static FOOTER = <BottomNavigator url={"/login"} />
    constructor(props) {
        super(props);
        this.state = {
            terminos: false
        };
    }

                        // TODO: RICKY TIENE QUE VERLO

    componentDidMount() {
        if (MDL.usuario.session) {
            SNavigation.replace("/");
            return;
        }
    }
    render() {
        return <SPage title={"index"} hidden >

            <SView col={"xs-12"} center backgroundColor={STheme.color.background}>
                <SHr height={40} />
                <SView col={"xs-12"} center>
                    <Container>
                        {/* <SHr height={8} /> */}
                        <SectionHeader />
                        {/* <SHr height={16} /> */}
                    </Container>
                </SView>
                <Container>
                    <SHr height={16} />
                    <SectionForm ref={ref => this._sectionForm = ref} />
                    <SHr height={50} />
                    <SText underLine onPress={()=>{
                        SNavigation.navigate("/admin/login")
                    }}>{"Login Gestor"}</SText>
                    {/* <SHr height={25} />
                    <SectionFooter onPress={() => {
                        this._sectionForm.submit();
                    }} />
                    <SHr height={35} />
                    <SectionApis />
                    <SectionRegister /> */}
                    <SHr height={50} />
                </Container>
            </SView>
        </SPage>
    }
}